export var QUERY_LIMIT = 5;
export var QUESTIONS = {
  id: 'questions',
  title: 'Q&A',
  filterSort: false
};
export var REVIEWS = {
  id: 'reviews',
  title: 'Reviews',
  filterSort: false
};